import ReactHtmlParser from 'react-html-parser';
import { Avatar, Box, Button, Divider, Flex, Heading } from '@chakra-ui/react';
import { Element } from 'react-scroll';
import { FC } from 'react';
import { LinkIcon } from '@chakra-ui/icons';
import { useTranslation } from 'next-i18next';

import { EventType } from '@lib/types';

import { AgendaTable } from '../chime/Agenda';

type Props = {
  event: EventType;
};

const EventInfo = ({ event }: Props) => {
  const { t } = useTranslation(['event', 'common']);

  const InfoHeading = ({ children }: any) => {
    return (
      <Heading fontWeight="700" fontSize="18px" lineHeight="34px" mb="8">
        {children}
      </Heading>
    );
  };

  return (
    <Flex w="full" direction="column">
      {/* Description section */}
      <Box>
        <Element name="description">
          <InfoHeading>{t('event:Description')}</InfoHeading>
        </Element>
        <Box height="auto" className="ck-content">
          {ReactHtmlParser(event.description)}
        </Box>
      </Box>

      {/* Agenda section */}
      {event.agendas && (
        <>
          <Divider my="12" />
          <Box>
            <Element name="agenda">
              <InfoHeading>{t('event:Agendas')}</InfoHeading>
            </Element>
            <AgendaTable event={event} />
          </Box>
        </>
      )}

      {/* Notice section */}
      <>
        <Divider my="12" />
        <Box>
          <Element name="notice">
            <InfoHeading>{t('event:Notices')}</InfoHeading>
          </Element>
          <Box height="auto" className="ck-content">
            {event.notice
              ? ReactHtmlParser(event.notice)
              : t('event:Notices description')}
          </Box>
        </Box>
      </>

      {/* Host section */}
      <>
        <Divider my="12" />
        <Box>
          <Element name="host">
            <InfoHeading>{t('event:Host')}</InfoHeading>
          </Element>
          <Flex flexDirection="row">
            <Avatar
              w="100px"
              h="100px"
              name={event.host.name}
              src={event.host.profilePic}
              border="none"
            />
            <Flex flexDirection="column" justifyContent="center" ml="4">
              <Heading as={'h3'} fontSize="18px" lineHeight="34px">
                {event.host.name}
              </Heading>
              {event.host.profileLink && (
                <Button
                  as={'a'}
                  href={event.host.profileLink}
                  w="fit-content"
                  target="_blank"
                  leftIcon={<LinkIcon />}
                  variant="ghost"
                  _hover={{ bg: 'none', textDecoration: 'underline' }}
                  _focus={{ outline: 'none' }}
                >
                  {t('common:Website')}
                </Button>
              )}
            </Flex>
          </Flex>
        </Box>
      </>
    </Flex>
  );
};

export default EventInfo;
